module.exports = __webpack_public_path__ + "img/37.40dc54ee.svg";